import BaseService from './base.service'

class CarService extends BaseService {
    getClientCars() {
        return new Promise((resolve, reject) => {
            return this.request().post({
                method: 'Car.getClientCars',
            })
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(this.errorWrapper(error.response))
                })
        })
    }

    createClientCar(params) {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Car.createClientCar',
                    params,
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(this.errorWrapper(error.response))
                })
        })
    }

    updateClientCar() {
    // return new Promise((resolve, reject) => {
    //     return this.request().post({
    //         method: 'Car.updateClientCar',
    //     })
    //         .then(response => {
    //             resolve(response.data)
    //         }).catch(error => {
    //             reject(this.errorWrapper(error.response))
    //         })
    // })
    }

    deleteClientCar(params) {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Car.deleteClientCar',
                    params,
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(this.errorWrapper(error.response))
                })
        })
    }

    getCarsHistory() {
        return new Promise((resolve, reject) => {
            return this.request().post({
                method: 'Car.getCarsHistory',
            })
                .then(response => resolve(response.data?.response))
                .catch(error => reject(this.errorWrapper(error.response)))
        })
    }

    getCurrentOrders() {
        return new Promise((resolve, reject) => {
            return this.request().post({
                method: 'Car.getCurrentOrders',
            })
                .then(response => resolve(response.data?.response))
                .catch(error => reject(this.errorWrapper(error.response)))
        })
    }

    // params.orderId
    // params.orderDate
    cancelOrder(params) {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Car.cancelOrder',
                    params,
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(this.errorWrapper(error.response))
                })
        })
    }
}

export default new CarService()
